import React from "react";
import { Modal, Button, Icon, Popup } from "semantic-ui-react";
import Formsy from "formsy-react";
import { dispatch } from '@rematch/core';
class ExcelPlaybookConfirmationModal extends React.Component {
  state = {
    includeReferences: true,
    includeAttachments: true,
    format: "1", // Default to Separated
  };

  handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    const val = type === "checkbox" ? checked : value;
    this.setState({ [name]: val });

    if (this.props.onChange) {
      this.props.onChange(name, val);
    }
  };
  handleSubmit = async () => {
    let formData = this.state;
    formData.playbookId = this.props.selectedPracticeLibrary._id;
    this.props.closeExcelExportModal();
    await dispatch.lifeCycle.getPlaybookAsExcel(formData);
  };
  componentWillMount() {
    document.body.click();
  }
  render() {
    const { open, onClose, selectedPracticeLibrary, closeExcelExportModal } = this.props;
    const { includeReferences, includeAttachments, format } = this.state;
    return (
      <Modal open={open} onClose={onClose} size="mini">
        <Modal.Header>Export to Excel</Modal.Header>
        <Modal.Content>
          <Formsy>
            <p>
              <strong>{selectedPracticeLibrary.name}</strong>
            </p>
            <p>Are you sure you want to export this playbook?</p>

            <div style={{ marginBottom: 10, marginTop: 20 }}>
              <label><strong>Content to be included:</strong> <span style={{ color: 'red', marginBottom: 2 }}>*</span></label>

              <div style={{ display: "flex", alignItems: "center", marginTop: 10 }}>
                <div><input
                  type="checkbox"
                  name="includeAttachments"
                  checked={includeAttachments}
                  onChange={this.handleInputChange}
                /></div>
                <div style={{ marginLeft: 6, marginBottom: 1 }}>Attachment Links</div>
                <div style={{ marginLeft: 3, marginBottom: 8 }}><Popup
                    position="bottom center"
                    className="popupStyled"
                    inverted
                    trigger={<Icon style={{marginBottom: 4}} name="info circle" className="float-right" />}
                    content={<div>
                        Content links automatically generated by AI for each activity.
                        <br />
                        These links provide related resources or materials to support the activity.
                      </div>}
                /></div>
              </div>

              <div style={{ display: "flex", alignItems: "center", marginTop: 10 }}>
                <div><input
                  type="checkbox"
                  name="includeReferences"
                  checked={includeReferences}
                  onChange={this.handleInputChange}
                /></div>
                <div style={{ marginLeft: 6, marginBottom: 1 }}>Reference Links</div>
                <div style={{ marginLeft: 3, marginBottom: 8 }}><Popup
                    position="bottom center"
                    className="popupStyled"
                    inverted
                    trigger={<Icon style={{marginBottom: 4}} name="info circle" className="float-right" />}
                    content={<div>
                        Reference content that is manually curated and stored on the platform.
                        <br />
                        These serve as trusted sources or background material for the activities.
                      </div>}
                /></div>
              </div>

            </div>

            <div style={{ marginBottom: 10 , marginTop: 15}}>
              <label><strong>URLs should be:</strong> <span style={{ color: 'red', marginBottom: 2 }}>*</span></label>
              <div style={{ display: "flex", alignItems: "center", marginTop: 10 }}>
                <div><input
                  type="radio"
                  name="format"
                  value="0"
                  checked={format === "0"}
                  onChange={this.handleInputChange}
                /></div>
                <div style={{ marginLeft: 6, marginBottom: 1 }}>Combined</div>
                <div style={{ marginLeft: 3, marginBottom: 6 }}><Popup
                    position="bottom left"
                    className="popupStyled"
                    inverted
                    trigger={<Icon style={{marginBottom: 3}} name="info circle" className="float-right" />}
                    content='The labels are clickable and no separate link is provided.'
                /></div>
              </div>

              <div style={{ display: "flex", alignItems: "center", marginTop: 10 }}>
                <div><input
                  type="radio"
                  name="format"
                  value="1"
                  checked={format === "1"}
                  onChange={this.handleInputChange}
                /></div>
                <div style={{ marginLeft: 6, marginBottom: 1 }}>Separated</div>
                <div style={{ marginLeft: 3, marginBottom: 6 }}><Popup
                    position="bottom left"
                    className="popupStyled"
                    inverted
                    trigger={<Icon style={{marginBottom: 3}} name="info circle" className="float-right" />}
                    content='The labels and links of attachments and references are separated.'
                /></div>
              </div>
            </div>

            {/* <span style={{ color: "#a9a9a9" }}>
              This action will not export references and comments added at playbook/activity level.
            </span> */}
          </Formsy>
        </Modal.Content>

        <Modal.Actions className="actionInFormcy">
            <Button
                className="button-submit float-right"
                id='exportExcelPlaybook'
                disabled={!includeReferences && !includeAttachments}
                onClick={this.handleSubmit}
            > Export </Button>
            <Button
                id='exportExcelPlaybookCancel'
                className="button-cancel"
                onClick={closeExcelExportModal}
            > Cancel </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default ExcelPlaybookConfirmationModal;
